import React, { FunctionComponent, useRef } from 'react';
import { FormControl } from 'react-bootstrap';
import { Field, useField } from 'react-final-form';
import { Nullable } from '../../types';

type Props = {
  property: string;
  disabled?: boolean;
  label?: string;
  placement?: 'right' | 'left';
  labelClassName?: string;
} & Nullable<HTMLInputElement>;

export const CheckBoxField: FunctionComponent<Props> = ({
  property,
  disabled = false,
  label,
  placement = 'right',
  labelClassName,
}) => {
  const ref = useRef<HTMLInputElement>(null);
  const { input, meta } = useField(property, {
    type: 'checkbox',
  });
  let content = (
    <FormControl style={{ flex: 1 }} ref={ref} {...input} disabled={disabled} />
  );
  if (label) {
    content =
      placement === 'right' ? (
        <>
          {content}
          <span className={[labelClassName, 'ml-1'].join(' ')}>{label}</span>
        </>
      ) : (
        <>
          <span className={[labelClassName, 'mr-1'].join(' ')}>{label}</span>
          {content}
        </>
      );
  }
  return (
    <Field name={property} type="checkbox">
      {({ input, meta }) => (
        <>
          <div
            className="d-flex"
            style={{ cursor: 'pointer' }}
            onClick={() => input.onChange(!input.checked)}
          >
            {content}
          </div>
          {meta.error &&
            (meta.modified || meta.submitFailed) &&
            !meta.active && <span className="text-danger">{meta.error}</span>}
        </>
      )}
    </Field>
  );
};
